import React from 'react';
import { Link } from 'react-router-dom';
import { sectors } from './data';
import BgImage from "../../images/practiceArea/agreement.jpeg";

const Sectors = () => {
  return (
    <div className="workSans">
      <section
        className="relative h-[400px] md:h-[450px] flex items-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(5, 33, 55, 0.9), rgba(5, 33, 55, 0.9)), url(${BgImage})`,
        }}
      >
        <div className="container mx-auto px-6 text-white">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Industries</h1>

          <div className="flex items-center text-sm md:text-base space-x-2 mb-6">
            <Link to="/" className="text-blue-300 hover:underline">
              Home
            </Link>
            <span className="text-[#d11c1c] font-bold">»</span>
            <span className="text-white">Industries</span>
          </div>

          <hr className="border-t border-white opacity-10 mb-6" />
          <p className="text-lg md:text-l mb-6 text-white">
            At Lawberon Legals & Co, we proudly serve clients across various industries, offering tailored legal solutions to meet the unique challenges of each sector. Our team brings deep industry knowledge and legal expertise to help businesses and individuals navigate complex legal matters. Explore the sectors we specialize in:
          </p>

          <Link
            to="/book"
            className="inline-block bg-[#d11c1c] text-white text-xs md:text-sm font-semibold tracking-wide uppercase py-3 px-6 rounded-sm shadow hover:bg-[#b81616] transition"
          >
            Speak with a Senior Legal Consultant →
          </Link>
        </div>
      </section>
      <div className="px-[6%]">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 my-4">
          {sectors.map((item, index) => (
            <div key={index} className="bg-[#FAFAFA] rounded-md py-6 px-4">
              <p className="text-[15px] font-extrabold text-[#052137]">{item.category}</p>
              <div className="my-4">
                {item.item.map((sector, index) => (
                  <div key={index}>
                    <Link to={`/industries/${item.category.toLowerCase().replace(/\s+/g, '-')}`}>
                      <p className="text-[14px] p-4 hover:bg-[#05213787] rounded-md cursor-pointer">{sector.title}</p>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Sectors;
